var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 98,
    viewBox: "0 0 91 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7563 16.7666C15.7563 16.7666 34.7667 6.45672 44.27 1.29567C45.9997 0.370282 47.9149 -0.0718115 49.8418 0.00949076C52.7237 0.201397 56.151 3.22698 56.151 3.22698L90.6052 40.6242V80.5937H74.567V98H37.1406L3.28087 61.252C1.45245 59.2105 0.3125 56.3319 0.3125 53.5145C0.3125 52.212 0.989695 50.1746 1.50135 49.0027L15.7563 16.7666ZM18.3108 19.539V67.6666C18.3184 69.8837 18.3899 71.8477 20.1844 73.8239L38.702 93.9169H70.8048V76.5106L18.3108 19.539ZM63.6641 16.7706C60.2819 13.1122 56.8583 9.50272 53.3557 5.97899C52.2195 4.8888 51.2225 4.0681 49.3302 4.0926C47.9381 4.14976 46.057 4.8888 46.057 4.8888L24.1686 16.7666L63.6641 16.7706Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg15);
export default __webpack_public_path__ + "static/media/15.6bb24b8c045bc8aa27627ce78b158bbd.svg";
export { ForwardRef as ReactComponent };